<script lang="ts">
  import {writable} from 'svelte/store';

  import FontSelection from '../FontSelector/FontSelection.svelte';
  import {onDestroy, onMount} from 'svelte';
  import {getInstance} from '../../../../services/animation';
  import editorStore from '../../../../lib/editor/editor.store';
  import {attachPopup, popupboxfont} from '../../PopupBox/PopupBox.svelte';
  import editorInstance from '../../../../lib/editor/editor';
  import {templateFontStore} from '../../../../services/animation/font-loader';

  export let font: string;
  export let primary: boolean = false;
  let selectedStore = writable(false);

  let fontString = writable<string>('');
  let fontNode: HTMLElement | null = null;

  function onFontFamilyChanged(font: any, isUserFont: boolean) {
    editorInstance.history.addHistory('font change');
    fontString.set(font.label);
    templateFontStore.update(store => {
      store[primary ? 0 : 1] = font.label;
      return store;
    });
    const instance = getInstance();
    if (instance) {
      instance.setMetaData({fontFamily: font});
      instance.templateLoader.recomputeTemplateMetadata();
      instance.recomputeCaptionTextSize();
    }
  }
  function openFontPopup() {
    selectedStore.set(true);
    if (primary) popupboxfont.set('primary-font');
    else popupboxfont.set('secondary-font');
    if (fontNode)
      attachPopup(fontNode, FontSelection, {
        onFontFamilyChanged,
        originalFont: font,
        targetSelector: primary ? '.primary-font' : '.secondary-font'
      });
  }

  let subscription = popupboxfont.subscribe(value => {
    selectedStore.set(false);

    if (value != 'none') {
      if (primary && value == 'primary-font') selectedStore.set(true);
      else if (!primary && value == 'secondary-font') selectedStore.set(true);
    }
  });

  onDestroy(subscription);

  function getElementsWithFont(font: string): HTMLElement[] {
    const targetSelector = primary ? '.primary-font' : '.secondary-font';
    const elements = document.querySelectorAll(targetSelector);
    const elementsWithFont = [];
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      const style = window.getComputedStyle(element);
      if (style.fontFamily.includes(font)) {
        elementsWithFont.push(element);
      }
    }
    return elementsWithFont as HTMLElement[];
  }
  function onMouseOver() {
    // Get all elements on page with the font variable being the fontFamily
    const elements = getElementsWithFont($fontString);
    editorInstance.ui.highlight(elements);
  }
  function onMouseLeave() {
    editorInstance.ui.removeHighlight();
  }

  onMount(() => {
    fontString.set(font);

    if ($popupboxfont != 'none') {
      if (primary && $popupboxfont == 'primary-font') selectedStore.set(true);
      else if (!primary && $popupboxfont == 'secondary-font') selectedStore.set(true);
    }
  });
</script>

<div class="flex w-full flex-col gap-2" on:focus={onMouseOver} on:mouseover={onMouseOver} on:mouseleave={onMouseLeave}>
  <div class="label text-sm" id="sb-{primary ? 'primary' : 'secondary'}-font">
    {primary ? 'Primary' : 'Secondary'} Font
  </div>
  <button
    bind:this={fontNode}
    class="flex items-center rounded-xl border border-zinc-300 px-4 py-3 {$selectedStore ? 'bg-zinc-100' : ''}"
    on:click={openFontPopup}
    on:keydown={openFontPopup}
  >
    <span class="block truncate text-xs font-bold">{$fontString}</span>
    <i class="fa fa-angle-right ml-auto block"></i>
  </button>
</div>

<style lang="postcss">
  .label {
    @apply block font-bold;
  }
</style>
